import { createAction } from '@reduxjs/toolkit';

export const closeNotificationAction = createAction('util/closeNotificationAction');
export const errorAction = createAction('util/errorAction');
export const initAction = createAction('util/initAction');
export const setNotificationAction = createAction('util/setNotificationAction');
export const setPushAction = createAction('util/setPushAction');
export const successAction = createAction('util/successAction');
